import uiConstants from '../constants/uiConstants';

const currentPage = JSON.parse(sessionStorage.getItem('currentPage')) ? JSON.parse(sessionStorage.getItem('currentPage')) : 'Dashboard';
const darkMode = JSON.parse(localStorage.getItem('darkMode')) ? JSON.parse(localStorage.getItem('darkMode')) : false;
const dictionnary = JSON.parse(localStorage.getItem('dictionnary')) ? JSON.parse(localStorage.getItem('dictionnary')) : true;
const dictionnaryAlign = JSON.parse(localStorage.getItem('dictionnaryAlign')) ? JSON.parse(localStorage.getItem('dictionnaryAlign')) : true;

const initialState = {
  currentPage,
  darkMode,
  dictionnaryAlign,
  dictionnary,
  currentGroup: 0,
};

export default function ui(state = initialState, action) {
  switch (action.type) {
    case uiConstants.CHANGE_PAGE_TITLE:
      return {
        ...state,
        currentPage: action.title,
      };
    case uiConstants.CHANGE_DARK_MODE:
      return {
        ...state,
        darkMode: action.darkMode,
      };
    case uiConstants.CHANGE_DICTIONNARY:
      return {
        ...state,
        dictionnary: action.dictionnary,
      };
    case uiConstants.CHANGE_DICTIONNARY_ALIGN:
      return {
        ...state,
        dictionnaryAlign: action.dictionnaryAlign,
      };
    case uiConstants.SET_CURRENT_GROUP:
      return {
        ...state,
        currentGroup: action.group,
      };
    default:
      return state;
  }
}
